import { Box, Grid } from "@mui/material";
import Header from "./components/Header";
import ImageViewer from "./components/ImageViewer";
import OwnerInfo from "./components/OwnersInfo";
import OfferContent from "./components/OfferComponent";
import ExpandableAccordion from "./components/Summary";
import {
  LabelOutlined,
  ListAlt,
  SellOutlined,
  Subject,
  Timeline,
  Toc,
  VerticalSplitOutlined,
  ViewModuleOutlined,
} from "@mui/icons-material";
import Listings from "./contents/Listings";
import SellerDetail from "./components/SellersDetail";
import DescriptionContent from "./contents/DescriptionContent";
import TraitContent from "./contents/TraitContent";
import AboutOwner from "./contents/AboutOwner";
import DetailsContent from "./components/Details";
import Footer from "./components/Footer";
import ImageCard from "./components/ImageList";
import ImgListContent from "./contents/ImageLIstContent";

function App() {
  const ownerName = "Milady Maker";
  return (
    <div>
      <Header />
      <Grid container spacing={1}>
        <Grid item xs={12} sm={5}>
          <ImageViewer />
          <Box mt={2}></Box>
          <SellerDetail
            status={true}
            icon={<Subject />}
            title='Description'
            content={<DescriptionContent />}
          />
          <SellerDetail
            icon={<LabelOutlined />}
            title='Traits'
            content={<TraitContent />}
          />
          <SellerDetail
            icon={<VerticalSplitOutlined />}
            title={`About ${ownerName}`}
            content={<AboutOwner />}
          />
          <SellerDetail
            icon={<ListAlt />}
            title='Details'
            content={<DetailsContent />}
          />
        </Grid>

        <Grid item xs={12} sm={7}>
          <OwnerInfo
            ownerName={ownerName}
            title={"Milady 1780"}
            ownedBy={"294693"}
            views={"245"}
            fav={3}
            number={"9,345"}
          />
          <OfferContent
            hours={1}
            minutes={20}
            seconds={60}
            endDate={"May 22, 2023"}
            endTime={"04:35 PM"}
            offerUSD={"7,447.89"}
            offerEth={"4.0198 WETH"}
          />
          <ExpandableAccordion icon={<Timeline />} title={"Price History"} />
          <ExpandableAccordion
            icon={<SellOutlined />}
            title={"Listings"}
            content={<Listings />}
          />
          <ExpandableAccordion icon={<Toc />} title={"Offers"} />
        </Grid>
      </Grid>
      <ExpandableAccordion
        title='More From This Collection'
        icon={<ViewModuleOutlined />}
        content={<ImgListContent />}
      />
      <Footer />
    </div>
  );
}

export default App;
